module.exports = __webpack_public_path__ + "img/Frame_31.6fd9d491.png";